import { useEffect, useRef } from "react";
import { api, setStoredSessionToken } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const run = async () => {
      const hash = window.location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      if (!match) {
        window.location.replace("/login");
        return;
      }
      const session_id = decodeURIComponent(match[1]);
      try {
        const { data } = await api.post("/auth/session", { session_id });
        // Persist the token to localStorage as a Bearer fallback. iOS PWA
        // standalone mode often loses the cookie partition between Safari
        // (where OAuth completes) and the home-screen launched PWA. The
        // localStorage entry is shared same-origin and keeps us logged in.
        if (data?.session_token) {
          setStoredSessionToken(data.session_token);
        }
        // Remove fragment and redirect to dashboard
        window.location.replace("/");
      } catch (e) {
        console.error("Auth exchange failed", e);
        window.location.replace("/login");
      }
    };
    run();
  }, []);

  return (
    <div className="h-screen w-screen login-mesh flex items-center justify-center">
      <div className="rounded-2xl bg-white/70 backdrop-blur-xl border border-white/60 px-8 py-6 shadow-warm-lg flex items-center gap-4">
        <div className="h-6 w-6 rounded-full border-2 border-terracotta border-t-transparent animate-spin" />
        <p className="font-heading text-brand-primary">Signing you in…</p>
      </div>
    </div>
  );
}
